import { FieldPattern } from '..';

import {
  CURRENT_STATE,
  DISTRICT_ASYNC_SELECT
} from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import DependentField from '../DependentField';

class DistrictComboBoxFieldModel extends DependentField {
  readonly type: string = DISTRICT_ASYNC_SELECT;
  searchKey: string;
  enableDefaultSuggestion: boolean;
  dependentFields: string[];
  isFieldDisabled: boolean;
  stateFieldName: string;
  mobilePlaceholder: string;

  constructor(districtFieldData: FormFieldsType, initialValue: string) {
    super(districtFieldData, initialValue);
    this.searchKey = districtFieldData.search_key ?? '';
    this.enableDefaultSuggestion =
      districtFieldData.enable_default_suggestion ?? false;
    this.dependentFields = districtFieldData.dependent_fields ?? [];
    this.isFieldDisabled = false;
    this.stateFieldName = districtFieldData.state_field_name ?? CURRENT_STATE;
    this.mobilePlaceholder = districtFieldData.mobile_placeholder ?? '';
  }

  match<T>(p: FieldPattern<T>): T {
    return p.DistrictComboBoxField(this);
  }
}

export default DistrictComboBoxFieldModel;
